export enum FieldStatus {
  CREATED_MANUALLY = 'createdManually',
  CREATED_BY_MERGE = 'createdByMerge',
  CREATED_BY_SPLIT = 'createdBySplit',
  IMPORTED_FROM_LAD = 'importedFromLad',
  MERGED_INTO = 'mergedInto',
  SPLITTED_INTO = 'splittedInto',
  DISABLED_AFTER_EXPIRED_MERGE = 'disabledAfterExpiredMerge',
  DISABLED_AFTER_EXPIRED_SPLIT = 'disabledAfterExpiredSplit',
  RESTORED_AFTER_EXPIRED_MERGE = 'restoredAfterExpiredMerge',
  RESTORED_AFTER_EXPIRED_SPLIT = 'restoredAfterExpiredSplit',
}
